<template>
  <div>
    <div id="menubox" style="background-color: #f9fbff">
      <el-menu
        ref="menu"
        class="el-menu-vertical-demo"
        text-color="#999"
        :unique-opened="true"
        router
        :default-active="activeIndex"
        @open="openIndex"
      >
        <label v-for="menu in menuList" :key="menu.title">
          <el-submenu
            :index="menu.code"
            v-if="!menu.path && menu.children.length > 0 && hasPerm(menu.code)"
          >
            <template slot="title">
              <img :src="menu.icon" style="height: 18px; width: 18px" />
              <span
                slot="title"
                @click="linkto(menu)"
                style="
                  font-size: 13px !important ;
                  height: 45px;
                  line-height: 45px;
                "
              >
                {{ menu.title }}
              </span>
            </template>
            <label v-for="item in menu.children" :key="item.title">
              <el-submenu
                :index="item.code"
                v-if="
                  !item.path && item.children.length > 0 && hasPerm(item.code)
                "
              >
                <template slot="title">
                  <span
                    slot="title"
                    @click="linkto(item)"
                    style="font-size: 13px !important"
                    >{{ item.title }}</span
                  >
                </template>
                <label v-for="i in item.children" :key="i.title">
                  <el-menu-item
                    :index="i.code"
                    v-if="i.path && hasPerm(i.code)"
                    style="height: 45px; line-height: 45px"
                  >
                    <template slot="title">
                      <span slot="title" style="font-size: 13px !important">{{
                        i.title
                      }}</span>
                    </template>
                  </el-menu-item>
                </label>
              </el-submenu>
              <el-menu-item
                :index="item.code"
                v-if="item.path && hasPerm(item.code)"
                style="
                  /* background-color: #f9fbff; */
                  height: 45px;
                  line-height: 45px;
                "
              >
                <template slot="title">
                  <!--<img :src="item.icon" style="height: 18px; width: 18px">-->
                  <span slot="title" style="font-size: 13px !important">{{
                    item.title
                  }}</span>
                </template>
              </el-menu-item>
            </label>
          </el-submenu>
          <el-menu-item
            :index="menu.code"
            v-if="menu.path && hasPerm(menu.code)"
            style="height: 45px; line-height: 45px"
            @click="closeSub"
          >
            <template slot="title">
              <img :src="menu.icon" style="height: 18px; width: 18px" />
              <span slot="title" style="font-size: 13px !important">{{
                menu.title
              }}</span>
            </template>
          </el-menu-item>
        </label>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "",
      subIndex: "",
      openeds: [],
    };
  },
  watch: {
    $route: function () {
      this.getNewActiveIndex();
    },
  },
  computed: {
    menuList: {
      get() {
        // return store.state.menus.menuList
        return JSON.parse(sessionStorage.getItem("setMenuList"));
      },
    },
  },
  mounted() {
    this.getNewActiveIndex();
  },
  methods: {
    getNewActiveIndex() {
      var path = this.$route.path.split("/");
      this.activeIndex = path[path.length - 1];
    },
    closeSub() {
      let that = this;
      this.$refs.menu.close(that.subIndex);
    },
    openIndex(index) {
      this.subIndex = index;
    },
    linkto(data) {},
    hasPerm(item) {
      let perm = sessionStorage.getItem("authoritys");
      return perm.indexOf(item) > -1;
    },
  },
};
</script>

<style scoped>
#menubox {
  width: 100%;
  height: calc(100vh - 64px);
  background: none;
  color: #999;
}
.is-active {
  background: linear-gradient(to right, #fff, #dbebff);
  position: relative;
  &::after {
    content: "";
    display: inline-block;
    width: 4px;
    height: 45px;
    background-color: #005eeb;
    position: absolute;
    right: 0px;
    top: 0px;
  }
}
img {
  width: 18px;
  padding-right: 10px;
}

/deep/ .el-submenu__title {
  height: 45px;
  line-height: 45px;
}

.el-menu-vertical-demo {
  text-align: left;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/menu.vue